<div
    [id]="id + '.' + filter.id"
    class="agpr-filterCheckboxes"
>
    <label
        class="agpr-filterCheckboxes-search"
    >
        <agpr-text-input
            [id]="id + '.' + filter.id + '.search'"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            [(ngModel)]="searchQuery"
            (ngModelChange)="search()"
            [style]="style"
            ariaLabel="Monitoring.autoTaggingTopicFilterSearch"
        ></agpr-text-input>
    </label>
    <agpr-filter-include-exclude
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <div class="agpr-filterCheckboxes-autoTaggingOptions">
            <agpr-checkbox
                [id]="id + '_autoTaggingTopics'"
                [name]="'filterCheckboxes-' + filter.id"
                [(ngModel)]="filter.autoTagOptions"
                [value]="taggingEnum.auto"
                [disabled]="value.length > 0"
                label="Monitoring.filter.tagging.allAutoTaggingTopics"
                (ngModelChange)="autoTagOptionsChanged()"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="id + '_onDemandTaggingTopics'"
                [name]="'filterCheckboxes-' + filter.id"
                [(ngModel)]="filter.autoTagOptions"
                [value]="taggingEnum.onDemand"
                [disabled]="value.length > 0"
                label="Monitoring.filter.tagging.allOnDemandTopics"
                (ngModelChange)="autoTagOptionsChanged()"
            ></agpr-checkbox>
    </div>
    <div class="agpr-filterCheckboxes-separator"></div>
    <div class="agpr-filterCheckboxes-toggleContainer">
        <agpr-button
            [id]="id + '.' + filter.id + anyOptionsSelected ? '.selectNone' : '.selectAll'"
            class="agpr-filterCheckboxes-allToggle"
            [style]="buttonTypes.link"
            (click)="selectItems()"
            [disabled]="filter.autoTagOptions.length > 0"
            [label]="anyOptionsSelected ? 'selectNone' : 'selectAll' | localize"
            aria-live="polite"
        >
        </agpr-button>
    </div>
    <agpr-scroll-panel>
        <ul
            class="agpr-filterCheckboxes-list"
            [attr.aria-label]="'filter' | localize"
        >
            <li
                *ngFor="let option of filteredOptions; let i = index"
                class="agpr-filterCheckboxes-item"
            >
                <agpr-checkbox
                    [id]="id + '_' + filter.id + '_checkbox_' + i"
                    class="agpr-filterCheckboxes-checkbox"
                    [name]="'filterCheckboxes-' + filter.id"
                    [value]="option.value"
                    [label]="option.label"
                    [(ngModel)]="value"
                    (ngModelChange)="handleChange()"
                    [disabled]="filter.autoTagOptions.length > 0"
                >
                    <span
                        *ngIf="option.count || option.count === 0"
                        class="agpr-filterCheckboxes-itemCount"
                        [pTooltip]="option.count | number"
                    >
                        <ng-container
                            *ngIf="filter.currentIncludeExclude === taggingIncludeExcludeEnum.include"
                        >
                            {{ option.count | significantDigits : 1}}
                        </ng-container>
                        <ng-container
                            *ngIf="filter.currentIncludeExclude === taggingIncludeExcludeEnum.exclude"
                        >
                            {{ option.numResults - option.count | significantDigits : 1}}
                        </ng-container>
                    </span>
                </agpr-checkbox>
            </li>
        </ul>
    </agpr-scroll-panel>
</div>
